import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const allProductData = createApi({
  reducerPath: "allProductData",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
   
    getAllProductsForSales: builder.query({
      query: () => ({
        url: "/Product/all-product-for-sales-hand",
        method: "GET",
      }),
    }),
    getProductsForSalesByPlateNumber: builder.query({
      query: (plateNumber) => ({
        url: `/Product/all-product-for-sales/${plateNumber}`,
        method: "GET",
      }),
    }),
 
    addSale: builder.mutation({
      query: (saleData) => ({
        url: "/Sale/add",
        method: "POST",
        body: saleData,
      }),
    }),
  }),
});

export const { 
  useGetAllProductsForSalesQuery,
  useGetProductsForSalesByPlateNumberQuery,
  useAddSaleMutation  
} = allProductData;
